/**
 * ux-product-sticky — pins the gallery column of the two-column PDP (≥750px)
 * while the info column scrolls past it.
 *
 * Broadcast's product-sticky.js pins [data-form-wrapper] only while that column
 * is the shorter of the two (formH < mediaH). As soon as the info column is the
 * longer one — the tablet layout, or a description accordion left open at any
 * width — nothing sticks, and the gallery's column empties out while the info
 * keeps scrolling (Figma 2684:3480). This script pins the gallery in exactly
 * that case, so the shorter column is the one in view, whichever it is.
 *
 * `--ux-pdp-sticky-top` is clamped the way Broadcast clamps its own: a gallery
 * taller than the viewport pins with its bottom GAP above the fold instead of
 * losing it. GAP matches product-sticky.js' default top/bottom spacing (the
 * header is not sticky on this store, so no header height is added).
 */
(function () {
  'use strict';

  var PDP = '.ux-pdp';
  var COLUMNS = '.product__page';
  var MEDIA = 'product-images';
  var FORM = '[data-form-wrapper]';
  var STICKY = 'ux-is-sticky';
  var TOP = '--ux-pdp-sticky-top';
  var GAP = 30;

  var root = document.querySelector(PDP);

  if (!root || !window.theme || !window.theme.isMobile) return;

  var columns = root.querySelector(COLUMNS);
  var media = root.querySelector(MEDIA);
  var form = root.querySelector(FORM);

  if (!columns || !media || !form) return;

  var frame = null;

  function decide() {
    frame = null;

    var height = media.offsetHeight;

    if (window.theme.isMobile() || form.offsetHeight <= height) {
      media.classList.remove(STICKY);
      media.style.removeProperty(TOP);
      return;
    }

    media.style.setProperty(TOP, Math.min(GAP, window.innerHeight - height - GAP) + 'px');
    media.classList.add(STICKY);
  }

  function schedule() {
    if (frame === null) frame = window.requestAnimationFrame(decide);
  }

  if (window.ResizeObserver) {
    /* Both compared heights: images arriving change the gallery, an accordion
       opening changes the info column. */
    var observer = new ResizeObserver(schedule);
    observer.observe(media);
    observer.observe(form);
  }

  document.addEventListener('theme:resize', schedule);
  document.addEventListener('theme:form:sticky', schedule);

  schedule();
})();
